import React from "react"
import Heading from "../../common/Heading"
import "./Featured.css"
import FeaturedCard from "./FeaturedCard"

const Featured = () => {
  return (
    <section className='featured background'>
      <div className='container'>
        <Heading
          title='Browse By Property Category'
          subtitle="Whether you're looking to buy, rent, or build, Vista Hill Houses covers homes, villas, apartments, and commercial spaces."
        />
        <FeaturedCard />
      </div>
    </section>
  )
}

export default Featured
